import { Guid } from '@develop/ia-utils'
import { IaCookie } from '@/models/cookie'
import { useCookieManagerStore } from '~/stores/cookies'

export const useAnonymousUser = () => {
  const { setCookie, getCookie } = useCookieManagerStore()

  const getAnonymousUser = () => getCookie<string>(IaCookie.AnonymousUser)

  const getToken = () => {
    const anon = getAnonymousUser()
    if (anon)
      return anon

    const date = new Date()
    date.setDate(date.getDate() + 30)
    setCookie({ name: IaCookie.AnonymousUser, value: Guid.generate(), options: { expires: date } })

    return getAnonymousUser()
  }

  const removeToken = () => {
    setCookie({ name: IaCookie.AnonymousUser, value: '', options: { expires: new Date(0) } })
  }

  return {
    getToken,
    removeToken,
  }
}
